import Model from '../Model'
import moment from "moment/moment";
import {isNull} from "lodash";

export default class ApplicationForPayment extends Model {
    static updateController = new AbortController();

    getPrintableUrl() {
        return '';
        return route('api.v2.commercial-management.application-for-payment.download', [this.packageReference, this.id])
    }

    getDownloadUrl() {
        return '';
        return route('api.v2.commercial-management.application-for-payment.pdf', [this.packageReference, this.id])
    }

    disableSnapshots = false

    addSnapshot() {
        if (this.disableSnapshots) return
        let store = this.getSnapshotStore()
        let data = JSON.stringify(this.except(['localStateStorage']))
        if ((!store.states.length) || (store.states[store.states.length - 1] !== data)) {
            store.states.push(data);
            this.putSnapshotStore(store)
            eventBus.$emit('application-for-payments-history-state-updated', {
                applicationForPayment: this,
                states: store.states
            })
        }
    }

    clearSnapshots(fromPosition, count = null) {
        const store = this.getSnapshotStore()
        store.states.splice(fromPosition, isNull(count) ? store.states.length - fromPosition : count)
        this.putSnapshotStore(store);
    }

    getSnapshotStore() {
        if (!this.localStateStorage) {
            this.localStateStorage = {}
        }
        if (!this.localStateStorage['application-for-payments-history:' + this.id]) {
            this.localStateStorage['application-for-payments-history:' + this.id] = {states: []}
        }
        return this.localStateStorage['application-for-payments-history:' + this.id]
    }

    putSnapshotStore(store) {
        this.localStateStorage['application-for-payments-history-history:' + this.id] = store;
        // TODO - remove remote storage for now
        User.clearStorageKey('application-for-payments-history-history:' + this.id);
    }

    static async find(applicationForPaymentId) {
        const data = await Http.get(route('api.v2.commercial-management.application-for-payment', {id: applicationForPaymentId}), {})
        return this.make(data)
    }

    static async list(packageReference = null) {
        const data = await Http.get(route('api.v2.commercial-management.application-for-payment.list', {package_reference: packageReference}))
        return this.make(data)
    }

    async reload() {
        let afp = await ApplicationForPayment.find(this.id)
        Object.assign(this, afp)
    }

    static async create(packageReference, id) {
        ApplicationForPayment.updateController.abort()
        ApplicationForPayment.updateController = new AbortController();
        const url = route('api.v2.commercial-management.application-for-payment.create', {
            package_reference: packageReference,
            id: id,
        })
        await Http.send('post', url, {}, {
            signal: ApplicationForPayment.updateController.signal
        })
    }

    async save() {
        const url = route('api.v2.commercial-management.application-for-payment.store', {
            package_reference: this.packageReference,
            id: this.id,
        })
        const payload = this.constructor.parseAttributes({...this.getFormAttributes()})
        this.saving = true;
        eventBus.$emit('application-for-payment-saving', this);
        await Http.put(url, payload).then(() => {
            eventBus.$emit('application-for-payments-saved', this);
            this.loggedOut = false;
            this.saving = false;
            this.error = false;
        })
    }

    setAttributes(attributes) {
        super.setAttributes(attributes)
        let date = moment(attributes.date)
        this.formatted_date = date.format('DD/MM/YYYY')
        this.buildTokens()
    }

    buildTokens() {
        let tokens = []
        this.tokens = tokens.join('|').toLowerCase();
    }
}
